module.exports = __webpack_public_path__ + "static/img/round6.84949862.jpg";